import { CHANNEL_DETAIL } from "@/apollo/queries/channels";
import ChannelFeatureEpisodesGrid from "@/components/ChannelFeatureEpisodesGrid";
import Loading from "@/components/Loading";
import ChannelFeaturedMetaTags, {
  tags,
} from "@/components/MetaTags/ChannelFeaturedMetaTags";
import { useBreadcrumbs, useChannelDetailQuery } from "@/hooks";
import { getStoreId } from "@/lib/config";
import routes from "@/lib/routes";
import withMiddlewares from "@/middlewares/withMiddlewares";
import { useRouter } from "next/router";
import { useEffect } from "react";

export default function ChannelDetailFeatured() {
  const { setBreadcrumbs } = useBreadcrumbs();
  const router = useRouter();
  const id = parseInt(router.query.id, 10);

  const { loading, data } = useChannelDetailQuery({
    variables: { id },
  });
  const channel = data?.channel;

  useEffect(() => {
    setBreadcrumbs([
      { text: "ホーム", href: routes.home },
      { text: "月額商品一覧", href: routes.channels },
      { text: channel.name, href: routes.channelDetail(channel.id) },
      { text: "注目の番組" },
    ]);
  }, [channel]);

  return (
    <>
      {loading && <Loading fixed />}
      <ChannelFeaturedMetaTags channel={channel} />
      <ChannelFeatureEpisodesGrid
        header={{ text: `${channel.name}の注目の番組` }}
        id={id}
      />
    </>
  );
}

export const getServerSideProps = withMiddlewares(
  async ({ req, res, query }, { serverProps, error, apolloClient }) => {
    const id = parseInt(query.id, 10);
    const storeId = getStoreId();
    if (id == storeId) {
      res.writeHead(302, { Location: routes.store });
      res.end();
    }
    const {
      data: { channel },
    } = await apolloClient.query({
      query: CHANNEL_DETAIL,
      variables: { id },
      fetchPolicy: "network-only",
    });

    if (channel) {
      const metatags = tags(channel);
      return {
        props: {
          ...serverProps,
          error,
          metatags,
          initialApolloState: apolloClient.cache.extract(),
        },
      };
    } else {
      return { notFound: true };
    }
  }
);
